import { icon } from "../functions/icons";

export function Search({onChange, value, inputRef, className, placeholder = "Type een zoekopdracht..."}){
    return(
    <div className={`horizontal standard-margin-left phone-search topbar-background-color ${className}`}>
        {icon('search',17,"var(--standard-text-color)")}
        <input ref={inputRef} className="clean-input complete-width standard-margin" type={"text"} placeholder={placeholder} value={value} onChange={(event) => onChange(event.target.value)} />
    </div>
    )

}